<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5WQxC0/tc-custom/9781612438887.jpg?1700746446301" alt="This image is the cover for the book Fearless Flourishing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fearless Flourishing
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Take your lettering to the next level with beautiful, stylish flourishes.</b><br/><br/> You’ve mastered every letter, from capital A to lowercase z. Now you want your hand-drawn projects to have the ornate and extravagant look that is only achieved through flourishing. Whether you go for a delicate, stately, whimsical, bold, funky, or elegant look, flourishing is a wonderful way to develop a personal style and make your hand-lettering stand out. From basic theories and helpful practices to beautiful examples and complex compositions, this step-by-step workbook provides all the tools you need to flourish with confidence!<br/><br/><b>• Elegant Letter Embellishments<br/> • Fanciful Flourishes &amp; Filigree<br/> • Decorative Borders &amp; Frames</b><br/><b>• Stylish Artistic Elements</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alissa Chojnacki
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c65f786c